module.exports = __webpack_public_path__ + "img/psn-halo.de349fe2.svg";